import { TransportationMode } from "../TransportationMode";

export const TransportationModeLabels: Record<TransportationMode, string> = {
  [TransportationMode.MotorVehicle]: "Motor Vehicle",
  [TransportationMode.PublicTransport]: "Public Transport",
};
